import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
  type DatabaseMetaInfo,
  fetchAllMetaInfo,
  fetchMetaInfo,
} from '../services/metaInfoApi';

export const metaInfoQueryKey = (
  connectionId: string | null,
  database: string | null,
) => ['metainfo', connectionId, database] as const;

export const metaInfoListAllQueryKey = ['metainfo', 'all'] as const;

const FIVE_MINUTES = 5 * 60 * 1000;

export function useMetaInfo(
  connectionId: string | null,
  database: string | null,
) {
  return useQuery<DatabaseMetaInfo | null>({
    queryKey: metaInfoQueryKey(connectionId, database),
    queryFn: () => {
      if (!connectionId || !database) return null;
      return fetchMetaInfo(connectionId, database);
    },
    enabled: Boolean(connectionId && database),
    staleTime: FIVE_MINUTES,
  });
}

export function useAllMetaInfo(enabled = true) {
  return useQuery<DatabaseMetaInfo[]>({
    queryKey: metaInfoListAllQueryKey,
    queryFn: fetchAllMetaInfo,
    enabled,
    staleTime: FIVE_MINUTES,
  });
}

export function useInvalidateMetaInfo() {
  const qc = useQueryClient();
  return (connectionId: string, database: string) => {
    qc.invalidateQueries({ queryKey: metaInfoQueryKey(connectionId, database) });
    qc.invalidateQueries({ queryKey: metaInfoListAllQueryKey });
  };
}
